/**
 *  @class
 *  @function RemoveAll
 */
if (!customElements.get('remove-all')) {
  class RemoveAll extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      this.debouncedOnSubmit = debounce(() => {
        this.onSubmitHandler();
      }, 200);
      this.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }
    onSubmitHandler() {
      // WIN-1L it2 (2026-08-13): the drawer notes field was removed in B3 —
      // reading it here threw before the fetch, leaving the spinner running
      // forever and the cart uncleared. Null-safe now, and failures stop
      // the spinner instead of spinning silently.
      this.classList.add('loading');
      var notesEl = document.getElementById('mini-cart__notes');
      fetch(`${theme.routes.cart_clear_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify(notesEl ? { 'note': notesEl.value } : {})
      }).then(() => {
        this.classList.remove('loading');
        this.drawer.refresh();
      }).catch(() => {
        this.classList.remove('loading');
      });
    }
  }
  customElements.define('remove-all', RemoveAll);
}